import { z } from "zod";

/**
 * ActionItemNodeSchema - Content Schema for Action Item Node
 *
 * ActionItem nodes track investment-related action items and todos.
 *
 * Field naming convention:
 * - action: Action item description (what needs to be done)
 * - priority: high | medium | low
 * - status: todo | in-progress | done
 * - dueDate: Due date in YYYY-MM-DD format (optional)
 * - assignee: Assigned person (optional)
 * - notes: Additional notes (optional)
 */
export const ActionItemNodeSchema = z.object({
  // Protocol metadata
  type: z.literal("action-item"),
  version: z.literal(1),
  key: z.string(),

  // Business data
  action: z.string().min(1), // Action description (required)
  priority: z.enum(["high", "medium", "low"]).optional(),
  status: z.enum(["todo", "in-progress", "done"]).optional(),
  dueDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(), // YYYY-MM-DD
  assignee: z.string().optional(),
  notes: z.string().optional(),
}).strict();

export type ActionItemNode = z.infer<typeof ActionItemNodeSchema>;
